module.exports = __webpack_public_path__ + "img/939071d.svg";